/** @format — Single document card (grid / drawer) */

import { useRef, useState } from "react";
import DocumentActionsMenu from "./DocumentActionsMenu";
import DocumentThumbnail from "./DocumentThumbnail";
import type { DocumentItem } from "../types";

export default function DocumentGridCard({
  document,
  onOpen,
  onGoToShipment,
  showGoToShipment = true,
}: {
  document: DocumentItem;
  onOpen: (doc: DocumentItem) => void;
  onGoToShipment?: (doc: DocumentItem) => void;
  showGoToShipment?: boolean;
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const suppressCardClickRef = useRef(false);

  const handleGoToShipment = (doc: DocumentItem) => {
    suppressCardClickRef.current = true;
    onGoToShipment?.(doc);
    window.setTimeout(() => {
      suppressCardClickRef.current = false;
    }, 0);
  };

  return (
    <article
      className="flex h-[180px] min-w-0 flex-col overflow-hidden rounded-lg border border-neutral-200 bg-white"
      onClick={(event) => {
        if (menuOpen || suppressCardClickRef.current) return;
        if ((event.target as HTMLElement).closest("[data-prevent-card-click]")) return;
        onOpen(document);
      }}
    >
      <DocumentThumbnail document={document} variant="card" />
      <div className="flex shrink-0 items-start gap-1 p-2">
        <div className="min-w-0 flex-1">
          <p className="truncate text-xs font-medium text-[#0a0a0a]" title={document.name}>
            {document.name}
          </p>
          <p className="mt-1 truncate text-[10px] text-[#475367]">{document.dateLabel}</p>
        </div>
        <div data-prevent-card-click className="shrink-0">
          <DocumentActionsMenu
            document={document}
            onOpen={onOpen}
            onGoToShipment={handleGoToShipment}
            onOpenChange={setMenuOpen}
            showGoToShipment={showGoToShipment}
          />
        </div>
      </div>
    </article>
  );
}
